import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { OnboardState, RootState } from "@/types/store";

const initialState: OnboardState = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  profileImageBase64: null,
  secondaryEmail: "",
  documents: {
    ach: {
      base64: null,
      name: "",
      size: "",
    },
    liabilityInsurance: {
      base64: null,
      name: "",
      size: "",
    },
    sop: {
      base64: null,
      name: "",
      size: "",
    },
  },
};

export const OnboardSlice = createSlice({
  name: "OnboardSlice",
  initialState,
  reducers: {
    setFirstName: (state, { payload }) => {
      state.firstName = payload;
    },
    setLastName: (state, { payload }) => {
      state.lastName = payload;
    },
    setPhoneNumber: (state, { payload }) => {
      state.phoneNumber = payload;
    },
    setSecondaryEmail: (state, { payload }) => {
      state.secondaryEmail = payload;
    },
    setProfileImageBase64: (state, { payload }) => {
      state.profileImageBase64 = payload;
    },
    setAch: (state, { payload: { base64, name, size } }) => {
      state.documents.ach.base64 = base64;
      state.documents.ach.name = name;
      state.documents.ach.size = size;
    },
    setLiabilityInsurance: (state, { payload: { base64, name, size } }) => {
      state.documents.liabilityInsurance.base64 = base64;
      state.documents.liabilityInsurance.name = name;
      state.documents.liabilityInsurance.size = size;
    },
    setSop: (state, { payload: { base64, name, size } }) => {
      state.documents.sop.base64 = base64;
      state.documents.sop.name = name;
      state.documents.sop.size = size;
    },
    clearOnboardData: () => {
      return initialState;
    },
  },
});

export const {
  setFirstName,
  setLastName,
  setPhoneNumber,
  setSecondaryEmail,
  setProfileImageBase64,
  setAch,
  setLiabilityInsurance,
  setSop,
  clearOnboardData,
} = OnboardSlice.actions;

export default OnboardSlice.reducer;

export const useOnboardData = () => {
  const firstName = useSelector((state: RootState) => state.Onboard.firstName);
  const lastName = useSelector((state: RootState) => state.Onboard.lastName);
  const phoneNumber = useSelector(
    (state: RootState) => state.Onboard.phoneNumber
  );
  const secondaryEmail = useSelector(
    (state: RootState) => state.Onboard.secondaryEmail
  );
  const profileImageBase64 = useSelector(
    (state: RootState) => state.Onboard.profileImageBase64
  );
  const ach = useSelector((state: RootState) => state.Onboard.documents.ach);
  const liabilityInsurance = useSelector(
    (state: RootState) => state.Onboard.documents.liabilityInsurance
  );
  const sop = useSelector((state: RootState) => state.Onboard.documents.sop);

  return {
    firstName,
    lastName,
    phoneNumber,
    secondaryEmail,
    profileImageBase64,
    documents: {
      ach,
      liabilityInsurance,
      sop,
    },
  };
};

